export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14208.770e94c0.jpg";